import PromoNotifications from './PromoNotifications'
export default PromoNotifications



// WEBPACK FOOTER //
// ./src/molecules/PromoNotifications/index.js